<template>
  <div id="publishing-journal-website-publisher-policy">
    <div class="mar-b-40">
      <div class="ipub-p1 line-h-40 mar-b-20" style="display: flex; justify-content: end;">
        <ipub-button type="primary"
                     icon="iconAdd"
                     @click="add">
          Add New Menu
        </ipub-button>
      </div>
      <ipub-tree @edit="edit"
                 @delete="del"
                 @add="add"
                 @drag="setSort"
                 :tree="dataSource" />
    </div>

    <Add ref="publisher-policy-add"
         :tree="dataSource"
         :isVisable="isVisable"
         @confirm="confirm"
         @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
